import { MRT_SortingState } from 'material-react-table'
import axios from 'services/axios'
import apiService from './api'
import { Filter } from 'components/FilterDrawer/FilterDrawer.config'

export const fetchVerticalTableData = async (
  zoneEndpoint: string,
  from: number = 0,
  size: number = 100,
  searchValue?: string,
  sorting?: MRT_SortingState,
  filters?: Filter[],
  vertical?: string,
) => {
  const endpoint = 'verticalsTable'
  if (!zoneEndpoint) return

  const params = {
    from,
    size,
    zoneEndpoint,
    searchValue,
    sorting,
    filters,
    vertical,
  }
  const config = {
    params,
  }

  try {
    const { data } = await axios.get(endpoint, config)
    return data
  } catch (err) {
    apiService.handleApiError(err as object | undefined)
    throw new Error('Failed to fetch data')
  }
}

export const fetchCdtfaTableData = async (
  zoneEndpoint: string,
  from: number = 0,
  size: number = 100,
  searchValue?: string,
  sorting?: MRT_SortingState,
  filters?: Filter[],
  signal?: AbortSignal,
) => {
  const endpoint = 'verticalsTable/cdtfaTableData'
  if (!zoneEndpoint) return

  const params = {
    from,
    size,
    zoneEndpoint,
    searchValue,
    sorting,
    filters,
  }
  const config = {
    params,
    signal,
  }

  try {
    const { data } = await axios.get(endpoint, config)
    return data
  } catch (err) {
    apiService.handleApiError(err as object | undefined)
    throw new Error('Failed to fetch data')
  }
}

export const fetchCompanyOverviewTableData = async (
  zoneEndpoint: string,
  from: number = 0,
  size: number = 100,
  searchValue?: string,
  sorting?: MRT_SortingState,
  filters?: Filter[],
  signal?: AbortSignal,
) => {
  const endpoint = 'companyOverview/mainTableData'
  if (!zoneEndpoint) return

  const params = {
    from,
    size,
    zoneEndpoint,
    searchValue,
    sorting,
    filters,
  }
  const config = {
    params,
    signal,
  }

  try {
    const { data } = await axios.get(endpoint, config)
    return data
  } catch (err) {
    apiService.handleApiError(err as object | undefined)
    throw new Error('Failed to fetch data')
  }
}

export const fetchVerticalTableOverviewData = async (
  zoneEndpoint: string,
  searchValue?: string,
  filters?: Filter[],
) => {
  const endpoint = 'verticalsTable/overview'
  if (!zoneEndpoint) return

  const params = {
    zoneEndpoint,
    searchValue,
    filters,
  }
  const config = {
    params,
  }

  try {
    const { data } = await axios.get(endpoint, config)
    return data
  } catch (err) {
    apiService.handleApiError(err as object | undefined)
    throw new Error('Failed to fetch data')
  }
}

export const fetchOffshoreTableOverviewData = async (
  zoneEndpoint: string,
  searchValue?: string,
  filters?: Filter[],
) => {
  const endpoint = 'verticalsTable/offshore-overview'
  if (!zoneEndpoint) return

  const params = {
    zoneEndpoint,
    searchValue,
    filters,
  }
  const config = {
    params,
  }

  try {
    const { data } = await axios.get(endpoint, config)
    return data
  } catch (err) {
    apiService.handleApiError(err as object | undefined)
    throw new Error('Failed to fetch data')
  }
}

export const fetchFatcaTableOverviewData = async (zoneEndpoint: string, searchValue?: string, filters?: Filter[]) => {
  const endpoint = 'verticalsTable/fatca-overview'
  if (!zoneEndpoint) return

  const params = {
    zoneEndpoint,
    searchValue,
    filters,
  }
  const config = {
    params,
  }

  try {
    const { data } = await axios.get(endpoint, config)
    return data
  } catch (err) {
    apiService.handleApiError(err as object | undefined)
    throw new Error('Failed to fetch data')
  }
}

export const fetchCDTFATableOverviewData = async (
  zoneEndpoint: string,
  searchValue: string,
  filters?: Filter[],
  signal?: AbortSignal,
) => {
  const endpoint = 'verticalsTable/cdtfaOverview'
  if (!zoneEndpoint) return

  const params = {
    zoneEndpoint,
    searchValue,
    filters,
  }
  const config = {
    params,
    signal,
  }

  try {
    const { data } = await axios.get(endpoint, config)
    return data
  } catch (err) {
    apiService.handleApiError(err as object | undefined)
    throw new Error('Failed to fetch data')
  }
}

export const fetchCompanyOverviewTableOverviewData = async (
  zoneEndpoint: string,
  searchValue: string,
  filters?: Filter[],
  signal?: AbortSignal,
) => {
  const endpoint = 'companyOverview/mainOverview'
  if (!zoneEndpoint) return

  const params = {
    zoneEndpoint,
    searchValue,
    filters,
  }
  const config = {
    params,
    signal,
  }

  try {
    const { data } = await axios.get(endpoint, config)
    return data
  } catch (err) {
    apiService.handleApiError(err as object | undefined)
    throw new Error('Failed to fetch data')
  }
}

export const fetchEcommerceExtendedTableOverviewData = async (
  zoneEndpoint: string,
  searchValue: string,
  filters?: Filter[],
  signal?: AbortSignal,
) => {
  const endpoint = 'ecommerceExtended/mainOverview'
  if (!zoneEndpoint) return

  const params = {
    zoneEndpoint,
    searchValue,
    filters,
  }
  const config = {
    params,
    signal,
  }

  try {
    const { data } = await axios.get(endpoint, config)
    return data
  } catch (err) {
    apiService.handleApiError(err as object | undefined)
    throw new Error('Failed to fetch data')
  }
}

export const fetchEcommerceExtendedTableData = async (
  zoneEndpoint: string,
  from: number = 0,
  size: number = 100,
  searchValue?: string,
  sorting?: MRT_SortingState,
  filters?: Filter[],
) => {
  const endpoint = 'ecommerceExtended/mainTable'
  if (!zoneEndpoint) return

  const params = {
    from,
    size,
    zoneEndpoint,
    searchValue,
    sorting,
    filters,
  }
  const config = {
    params,
  }

  try {
    const { data } = await axios.get(endpoint, config)
    return data
  } catch (err) {
    apiService.handleApiError(err as object | undefined)
    throw new Error('Failed to fetch data')
  }
}

export const exportEntitiesCSV = async (
  zoneEndpoint: string,
  _source: { includes: string[] },
  type?: string,
  selectedIds?: Array<string>,
  searchValue?: string,
  sorting?: MRT_SortingState,
  currencyContext?: any,
) => {
  const endpoint = 'verticalsTable/exportEntitiesCSV'
  if (!zoneEndpoint) return

  const params = {
    searchValue,
    sorting,
  }

  const body = {
    zoneEndpoint,
    _source,
    type,
    selectedIds,
    currencyContext,
  }

  try {
    const { data } = await axios.post(endpoint, body, { params })
    return data
  } catch (err) {
    apiService.handleApiError(err as object | undefined)
    throw new Error('Failed to fetch data')
  }
}

export const fetchFilterOptions = async (zoneEndpoint: string, filtersInitialState: Filter[]) => {
  const endpoint = 'verticalsTable/filterOptions'
  if (!zoneEndpoint) return

  const params = {
    zoneEndpoint,
    filtersInitialState,
  }
  const config = {
    params,
    skipKeysConversion: true,
  }

  try {
    const { data } = await axios.get(endpoint, config)
    return data
  } catch (err) {
    apiService.handleApiError(err as object | undefined)
    throw new Error('Failed to fetch data')
  }
}

export const fetchEcomExtendedFilterOptions = async (zoneEndpoint: string, filtersInitialState: Filter[]) => {
  const endpoint = 'verticalsTable/ecom-extended/filters-options'
  if (!zoneEndpoint) return

  const params = {
    zoneEndpoint,
    filtersInitialState,
  }
  const config = {
    params,
    skipKeysConversion: true,
  }

  try {
    const { data } = await axios.get(endpoint, config)
    return data
  } catch (err) {
    apiService.handleApiError(err as object | undefined)
    throw new Error('Failed to fetch data')
  }
}

export const fetchEmptyTableValues = async (zoneEndpoint: string, keys: string[]) => {
  const endpoint = 'verticalsTable/get-empty-table-columns'
  if (!zoneEndpoint) return

  const params = {
    zoneEndpoint,
  }
  const config = {
    params,
  }

  const body = { keys }

  try {
    const { data } = await axios.post(endpoint, body, config)
    return data
  } catch (err) {
    apiService.handleApiError(err as object | undefined)
    throw new Error('Failed to fetch data')
  }
}

export const fetchEmptyEcommerceExtendedTableValues = async (zoneEndpoint: string) => {
  const endpoint = 'verticalsTable/get-empty-ecommerce-extended-table-columns'
  if (!zoneEndpoint) return

  const params = {
    zoneEndpoint,
  }
  const config = {
    params,
  }

  try {
    const { data } = await axios.get(endpoint, config)
    return data
  } catch (err) {
    apiService.handleApiError(err as object | undefined)
    throw new Error('Failed to fetch data')
  }
}
